import { RENDERING_DETAILS_TYPES } from "@core-ui/constants/RenderingDetails";
import React, { memo, ReactElement } from "react";
import classNames from "classnames";

import { DISCOUNT_TYPES, TEXTS } from "@core-ui/constants/BillDetails";
import styles from "../../../BillDetailItem.scss";

interface SavingsProps {
    key: string;
    totalSavings: number;
    discountType: string;
}

const Savings = ({ totalSavings, discountType, key }: SavingsProps): ReactElement | null => {
    if (key !== RENDERING_DETAILS_TYPES.GRAND_TOTAL || !totalSavings) return null;

    const className = classNames({
        [styles.rowSavings]: true,
        [styles.rowSavingsSuper]: discountType === DISCOUNT_TYPES.SUPER,
        [styles.rowSavingsDefault]: discountType !== DISCOUNT_TYPES.SUPER,
    });

    return (
        <div className={className}>
            {TEXTS.YOU_SAVE} <span className={styles.rupee}>{totalSavings}</span>
        </div>
    );
};

export default memo(Savings);
